/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_LinksInputs */

const en_landing_pricing_compare_links = /** @type {(inputs: Landing_Pricing_Compare_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outbound link policy`)
};

const zh_landing_pricing_compare_links = /** @type {(inputs: Landing_Pricing_Compare_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外链策略`)
};

/**
* | output |
* | --- |
* | "Outbound link policy" |
*
* @param {Landing_Pricing_Compare_LinksInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_links = /** @type {((inputs?: Landing_Pricing_Compare_LinksInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_LinksInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_links(inputs)
	return zh_landing_pricing_compare_links(inputs)
});
export { landing_pricing_compare_links as "landing.pricing.compare_links" }